import { startOfQuarter, endOfQuarter, formatISO } from 'date-fns';
import type { Locale } from '@atlassian/jira-common-constants/src/supported-locales.tsx';
import { formatWithLocale } from '@atlassian/jira-platform-utils-date-fns/src/main.tsx';

const DIFF_YEAR_FORMAT = 'MMM d, yyyy';
const MONTH_ONLY_FORMAT_SHORT = 'MMM';
const MONTH_ONLY_FORMAT_DIFF_YEAR = 'MMM, yyyy';
const MONTH_ONLY = 'MMMM';

export const formatNiceDate = (date: Date, locale: Locale) =>
	formatWithLocale(date, DIFF_YEAR_FORMAT, locale);

export const formatNiceMonthDate = (date: Date, locale: Locale) =>
	formatWithLocale(date, MONTH_ONLY_FORMAT_DIFF_YEAR, locale);

export const formatNiceQuarterDate = (date: Date, locale: Locale) =>
	`${formatWithLocale(startOfQuarter(date), MONTH_ONLY_FORMAT_SHORT, locale)}-${formatWithLocale(
		endOfQuarter(date),
		MONTH_ONLY_FORMAT_DIFF_YEAR,
		locale,
	)}`;

export const formatMonthOnlyDate = (date: Date, locale: Locale) =>
	formatWithLocale(date, MONTH_ONLY, locale);

export const formatIsoLocalDate = (date: Date) => formatISO(date, { representation: 'date' });
